var _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5001,
    cy: 11.2008,
    r: 1.4,
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5001,
    cy: 11.2008,
    r: 1.4,
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 11.1811C2.33229 11.1428 1.85337 11.0286 1.51256 10.6878C1.17175 10.347 1.05755 9.8681 1.01929 9.10039M5.9 11.2004H10.1M12.9 11.1811C13.6677 11.1428 14.1466 11.0286 14.4874 10.6878C15 10.1753 15 9.35031 15 7.70039V6.30039H11.71C11.1888 6.30039 10.9283 6.30039 10.7174 6.23187C10.2912 6.09338 9.95701 5.75923 9.81852 5.33301C9.75 5.12213 9.75 4.86155 9.75 4.34039C9.75 3.55865 9.75 3.16778 9.64722 2.85146C9.43949 2.21214 8.93825 1.7109 8.29894 1.50317C7.98261 1.40039 7.59174 1.40039 6.81 1.40039H1",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.2002H5.2",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.30078H3.8",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.80078H11.0249C12.0436 2.80078 12.553 2.80078 12.9675 3.04838C13.382 3.29597 13.6235 3.74446 14.1065 4.64143L15 6.30078",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDeliveryIcon);
export default __webpack_public_path__ + "static/media/truck-delivery-icon.2d3faa174af6498763246ec8b8607360.svg";
export { ForwardRef as ReactComponent };